module.exports = __webpack_public_path__ + "static/media/golgi-apparatus.61f4a3d3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/icons/golgi-apparatus.svg
// module id = 673
// module chunks = 0